/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ShipmentSummary } from "./ShipmentSummary";
import {
  ShipmentSummaryFromJSON,
  ShipmentSummaryFromJSONTyped,
  ShipmentSummaryToJSON,
  ShipmentSummaryToJSONTyped,
} from "./ShipmentSummary";

/**
 *
 * @export
 * @interface ShipmentListResponse
 */
export interface ShipmentListResponse {
  /**
   *
   * @type {Array<ShipmentSummary>}
   * @memberof ShipmentListResponse
   */
  shipments: Array<ShipmentSummary>;
  /**
   * Every shipment matching the filters, not just this page. Stated so the
   * list can never imply it is showing everything when it isn't.
   *
   * @type {number}
   * @memberof ShipmentListResponse
   */
  totalCount: number;
  /**
   *
   * @type {number}
   * @memberof ShipmentListResponse
   */
  page: number;
  /**
   *
   * @type {number}
   * @memberof ShipmentListResponse
   */
  pageSize: number;
}

/**
 * Check if a given object implements the ShipmentListResponse interface.
 */
export function instanceOfShipmentListResponse(
  value: object,
): value is ShipmentListResponse {
  if (!("shipments" in value) || value["shipments"] === undefined) return false;
  if (!("totalCount" in value) || value["totalCount"] === undefined)
    return false;
  if (!("page" in value) || value["page"] === undefined) return false;
  if (!("pageSize" in value) || value["pageSize"] === undefined) return false;
  return true;
}

export function ShipmentListResponseFromJSON(json: any): ShipmentListResponse {
  return ShipmentListResponseFromJSONTyped(json, false);
}

export function ShipmentListResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ShipmentListResponse {
  if (json == null) {
    return json;
  }
  return {
    shipments: (json["shipments"] as Array<any>).map(ShipmentSummaryFromJSON),
    totalCount: json["totalCount"],
    page: json["page"],
    pageSize: json["pageSize"],
  };
}

export function ShipmentListResponseToJSON(json: any): ShipmentListResponse {
  return ShipmentListResponseToJSONTyped(json, false);
}

export function ShipmentListResponseToJSONTyped(
  value?: ShipmentListResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    shipments: (value["shipments"] as Array<any>).map(ShipmentSummaryToJSON),
    totalCount: value["totalCount"],
    page: value["page"],
    pageSize: value["pageSize"],
  };
}
